"use client";

import { c as _c } from "react/compiler-runtime";
import { meta } from "@/lib/config";
import { useTheme } from "next-themes";
import { useCallback, useMemo } from "react";
export function useMetaColor() {
  const $ = _c(2);
  const {
    resolvedTheme
  } = useTheme();
  let t0;
  t0 = resolvedTheme !== "dark" ? meta.colors.light : meta.colors.dark;
  const metaColor = t0;
  const setMetaColor = _temp;
  let t1;
  if ($[0] !== metaColor) {
    t1 = {
      metaColor,
      setMetaColor
    };
    $[0] = metaColor;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp(color) {
  document.querySelector("meta[name=\"theme-color\"]")?.setAttribute("content", color);
}